/*
 * @Author: cyerogy cyerogy@163.com
 * @Date: 2025-04-04 10:05:23
 * @LastEditors: cyerogy cyerogy@163.com
 * @LastEditTime: 2025-04-04 10:10:41
 * @FilePath: \projectorder\src\store\modules\app.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios';
import Cookies from "js-cookie";
import { validEmpty, getLocalStorge, setLocalStorge } from "@/utils/validate";
const state = {
  
};

const mutations = {
};

const actions = {
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
